import {
  Brand,
  ErrorPage,
  Footer,
  NavBar,
  NavBarTabs,
  UserActions,
  RecessThemeProvider,
  Logo,
} from '@guildeducationinc/recess';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppErrorBoundary } from './components/ErrorBoundary';
import './app.scss';
import getDomainInfo from './utilities/getDomainInfo';

const App: React.FC = () => {
  const { domain } = getDomainInfo();

  return (
    <RecessThemeProvider>
      <AppErrorBoundary>
        <Router>
          <main role='main'>
            <NavBar>
              <Brand href='/partner' title='company brand logo'>
                <Logo className='navLogo' alt='Guild G logo' cobranded fullLogo></Logo>
              </Brand>
              <NavBarTabs />
              <UserActions
                primaryTitle='Create account'
                primaryHref={`https://redirect.${domain}.com/signup`}
                secondaryTitle='Sign in'
                secondaryHref={`https://redirect.${domain}.com/login`}
                testid='nav-user-actions'
              />
            </NavBar>
            <Routes>
              <Route
                path='*'
                element={
                  <ErrorPage
                    goBack={() => {
                      window.location.href = `https://students.${domain}.com`;
                    }}
                    message='This page is not found - error 404.'
                    className='errorPage'
                  />
                }
              />
            </Routes>
            <Footer
              className='footer'
              columns={[
                {
                  title: 'Contact Us',
                  links: [
                    {
                      href: 'https://help.guildeducation.com',
                      label: 'Help Center',
                    },
                    {
                      href: 'https://guild.force.com/helpcenter/s/contactsupport',
                      label: 'Contact a Coach',
                    },
                  ],
                },
              ]}
            />
          </main>
        </Router>
      </AppErrorBoundary>
    </RecessThemeProvider>
  );
};

export default App;
